import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  TextField,
  Button,
  Typography,
  IconButton,
  Portal,
  Stack,
  CardContent,
  Box,
  Tabs,
  Tab,
  Fade,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useAuth0 } from "@auth0/auth0-react";
import { useAppContext } from "../../../context/AppContext";
import { useAccountContext } from "src/context/AccountContext";
import { dismissItem } from "src/components/NewUserChecklist/dismissItem";
import ReviewDialog from "src/components/AccountPage/AccountManagementComponents/ReviewDialog.js";
import useAddLocation from "src/components/payments/hooks/useAddLocation";
import useAddNewUser from "src/components/payments/hooks/useAddNewUser";
import {
  PrimaryButton,
  CancelButton,
  SecondaryButton,
} from "src/components/Buttons/ModalButtons";
import addLocationIcon from "src/public/assets/icons/icons/newLocation.png";
import LocationInfoCard from "./LocationInfoCard";
import LocationHoursCard from "./LocationHoursCard";
import EmployeeSetupCard from "./EmployeeSetupCard";
import { useUserSelectedNotifications } from "src/context/UserNotificationsContext";
import { useAuth } from "src/context/AuthContext.js"; // Assuming subUserData is coming from this context
import CancelCloseDialog from "../CancelCloseDialog";

import dayjs from "dayjs";
import { set } from "lodash";
import { setConfig } from "dompurify";
import ConfirmDialog from "./ConfirmDialog";
import AddLocationSubmit from "./AddLocationSubmit";
import useNoCostNewUser from "src/components/payments/hooks/useNoCostNewUser";
import { Troubleshoot } from "@mui/icons-material";

const apiUrl = process.env.REACT_APP_API_URL;

const AddLocationModal = ({
  open,
  onClose,
  users,
  locations,
  fetchLocations,
  fetchUsers,
  totalUsers,
  totalLocations,
  refetchSubscriptionDetails,
  refreshSubscription,
  handleSubscriptionUpdate,
  subscriptionDetails,
  planDetails
  
  
  
}) => {
  const { handleReloadComponents, showSnackBar } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);
  const {
    accountData,
    onboardingData,
    fetchOnboardingRecord,
    fetchAccountData,
  } = useAccountContext();
  const [item, setItem] = useState("addLocation");
  const [openReviewDialog, setOpenReviewDialog] = useState(false);
  const { addNewLocation, addLocationLoading, addLocationError, success } =
    useAddLocation();
  const {
    addNoCostNewUser,
    addUserLoading,
    addUserError,
    success: newUserSuccess,
  } = useNoCostNewUser();
  const [hoursItem, setHoursItem] = useState("confirmHours");
  const {
    subUserData,
    username,
    logout: customLogout,
    resetContext,
  } = useAuth();
  const [selectedTab, setSelectedTab] = useState(0);
  const [isCancelCloseOpen, setIsCancelCloseOpen] = useState(false);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  //New Location Info
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [nameTouched, setNameTouched] = useState(false);
  const [emailTouched, setEmailTouched] = useState(false);
  const [phoneTouched, setPhoneTouched] = useState(false);
  const [locationNameTaken, setLocationNameTaken] = useState(false);
  //Confirm Hours
  const [confirmHours, setConfirmHours] = useState(false);
  const [defaultHoursChanged, setDefaultHoursChanged] = useState(false);
  const [isSaveHoursButtonDisabled, setIsSaveHoursButtonDisabled] =
    useState(false); // State to manage button disabled state
  //New User
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [pin, setPin] = useState("");
  const [showPin, setShowPin] = useState(false);
  const [newUserName, setNewUserName] = useState("");
  const [isSaveUserButtonEnabled, setIsSaveUserButtonEnabled] = useState(false);
  const [hideCreateUserButton, setHideCreateUserButton] = React.useState(false);
  const [isAssignEmployeeVisible, setIsAssignEmployeeVisible] = useState(false);
  const [confirmNewPin, setConfirmNewPin] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [userNameTaken, setUserNameTaken] = useState(false);
  const [isEditingUser, setIsEditingUser] = useState(false);
  //Transfer List
  const [checked, setChecked] = useState([]);
  const [right, setRight] = useState([]);
  const [assignedUser, setAssignedUser] = useState(null);
  const [assignedLocation, setAssignedLocation] = useState(null);
  const availableUsers = users?.filter(
    (user) => user.user_id !== subUserData.user_id,
  );
  const [left, setLeft] = useState(availableUsers);
  const [isNewUserSaved, setIsNewUserSaved] = useState(false);
  const [showConfirmNewPin, setShowConfirmNewPin] = useState(false);
  const [newUserId, setNewUserId] = useState(null);
  const [newUserCreated, setNewUserCreated] = useState(false);
  const [enableEditButtons, setEnableEditButtons] = useState(false);
  const [confirmUsers, setConfirmUsers] = useState(false);
  const [hoursWarning, setHoursWarning] = useState(false);
  const [usersWarning, setUsersWarning] = useState(false);
  //Confirm Dialog
  const [confirmHeader, setConfirmHeader] = useState("");
  const [confirmMessage, setConfirmMessage] = useState("");
  const [confirmSubText, setConfirmSubText] = useState("");
  const [defaultLeft, setDefaultLeft] = useState(availableUsers);

  const handleTabChange = (event, newValue) => {
    setIsAssignEmployeeVisible(false);
    if (newUserCreated === false) {
      setHideCreateUserButton(false);
    }
    if (isAssignEmployeeVisible && newUserCreated === false) {
      setHideCreateUserButton(false);
      setFirstName("");
      setLastName("");
      setPin("");
      setConfirmNewPin("");
      setShowConfirmNewPin(false);
      setShowPin(false);
      setUserName("");
      setNewUserName("");
      setIsAdmin(false);
    }
    setSelectedTab(newValue);
    setChecked([]);
  };

  const handleOpenCancelCloseDialog = () => {
    const areArraysEqual = (left, defaultLeft) => {
      if (left?.length !== defaultLeft?.length) return false;

      const leftIds = left?.map((item) => item?.user_id).sort();
      const defaultLeftIds = defaultLeft?.map((item) => item?.user_id).sort();

      return leftIds?.every((id, index) => id === defaultLeftIds[index]);
    };

    if (
      defaultHoursChanged ||
      !confirmUsers ||
      nameTouched ||
      emailTouched ||
      phoneTouched ||
      !areArraysEqual(left, defaultLeft) // Add array comparison condition here
    ) {
      setIsCancelCloseOpen(true); // Open the cancel-close dialog

      // Handle warnings independently
      if (defaultHoursChanged && !confirmHours) {
        setHoursWarning(true); // Show hours warning if needed
      }

      if (!confirmUsers || usersMoved) {
        setUsersWarning(true); // Show users warning if needed
      }
    } else {
      // Close dialog if no conditions are met

      onClose();
    }
  };

  const handleCloseCancelCloseDialog = () => {
    setIsCancelCloseOpen(false);
  };

  const handleCancelClose = () => {
    setIsCancelCloseOpen(false);
    onClose();
  };

  const handleCloseReviewDialog = () => {
    setOpenReviewDialog(false);
  };

  const handleOpenReviewDialog = () => {
    if (openConfirmDialog === true) {
      setOpenConfirmDialog(false);
    }
    setOpenReviewDialog(true);
  };

  const handleOpenConfirmDialog = () => {
    setOpenConfirmDialog(true);
  };

  useEffect(() => {
    if (!open) {
      setOpenReviewDialog(false);
    }
  }, [open]);

  const { user, getAccessTokenSilently } = useAuth0();
  const userId = user.sub;

  //Location Info Hooks
  useEffect(() => {
    const validateForm = () => {
      const isValidName = name.trim() !== "";
      const isValidEmail = validateEmail(email);
      const isValidPhone = validatePhoneNumber(phone);
      setIsFormValid(isValidName && isValidEmail && isValidPhone);
    };

    validateForm();
  }, [name, email, phone]);

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{3})(\d{0,3})(\d{0,4})$/);
    if (match) {
      return `(${match[1]})${match[2] ? " " + match[2] : ""}${match[3] ? "-" + match[3] : ""}`;
    }
    return value;
  };

  const handleNameChange = (e) => {
    let inputValue = e.target.value;

    // Only allow alphanumeric characters (letters and numbers)
    inputValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, "");

    // Capitalize the first letter and keep the rest of the text unchanged
    const capitalizedValue =
      inputValue.charAt(0).toUpperCase() + inputValue.slice(1);

    setName(capitalizedValue);
    setNameTouched(true);
  };

  const handleBlur = () => {
    // Trim trailing spaces when the input loses focus
    const trimmedName = name.trim();
    setName(trimmedName);
  };

  const handleEmailChange = (e) => {
    let inputValue = e.target.value;

    // Allow only alphanumeric characters, '@', and '.'
    const validEmail = inputValue.replace(/[^a-zA-Z0-9@.]/g, "");

    setEmail(validEmail);
  };

  const handleEmailBlur = () => {
    // Trim trailing spaces and special characters like periods at the end of the email
    let trimmedEmail = email.trim();
    trimmedEmail = trimmedEmail.replace(/[^\w@.]+$/, "");

    // Only update the email state if it has changed
    if (email !== trimmedEmail) {
      setEmail(trimmedEmail);
    }

    // Mark email as touched only after the blur event
    setEmailTouched(true);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "").slice(0, 10); // Allow only digits, max length 10
    setPhone(formatPhoneNumber(value));
  };

  const handlePhoneBlur = () => {
    // Mark phone as touched only when the user leaves the field
    setPhoneTouched(true);
  };

  const validatePhoneNumber = (phone) => {
    const phoneRegex = /^\(\d{3}\) \d{3}-\d{4}$/; // Example: (123) 456-7890
    return phoneRegex.test(phone);
  };

  //Location Hours Hooks

  const [businessHours, setBusinessHours] = useState({
    Sunday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: true },
    Monday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: false },
    Tuesday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: false },
    Wednesday: {
      start_time: "09:00 AM",
      end_time: "05:00 PM",
      is_closed: false,
    },
    Thursday: {
      start_time: "09:00 AM",
      end_time: "05:00 PM",
      is_closed: false,
    },
    Friday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: false },
    Saturday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: true },
  });

  const [startTimeValues, setStartTimeValues] = useState({
    Sunday: "09:00 AM",
    Monday: "09:00 AM",
    Tuesday: "09:00 AM",
    Wednesday: "09:00 AM",
    Thursday: "09:00 AM",
    Friday: "09:00 AM",
    Saturday: "09:00 AM",
  });

  const [endTimeValues, setEndTimeValues] = useState({
    Sunday: "05:00 PM",
    Monday: "05:00 PM",
    Tuesday: "05:00 PM",
    Wednesday: "05:00 PM",
    Thursday: "05:00 PM",
    Friday: "05:00 PM",
    Saturday: "05:00 PM",
  });

  const defaultBusinessHours = {
    Sunday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: true },
    Monday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: false },
    Tuesday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: false },
    Wednesday: {
      start_time: "09:00 AM",
      end_time: "05:00 PM",
      is_closed: false,
    },
    Thursday: {
      start_time: "09:00 AM",
      end_time: "05:00 PM",
      is_closed: false,
    },
    Friday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: false },
    Saturday: { start_time: "09:00 AM", end_time: "05:00 PM", is_closed: true },
  };

  const defaultStartTimeValues = {
    Sunday: "09:00 AM",
    Monday: "09:00 AM",
    Tuesday: "09:00 AM",
    Wednesday: "09:00 AM",
    Thursday: "09:00 AM",
    Friday: "09:00 AM",
    Saturday: "09:00 AM",
  };

  const defaultEndTimeValues = {
    Sunday: "05:00 PM",
    Monday: "05:00 PM",
    Tuesday: "05:00 PM",
    Wednesday: "05:00 PM",
    Thursday: "05:00 PM",
    Friday: "05:00 PM",
    Saturday: "05:00 PM",
  };

  const handleResetHours = () => {
    setBusinessHours(defaultBusinessHours);
    setStartTimeValues(defaultStartTimeValues);
    setEndTimeValues(defaultEndTimeValues);
    setConfirmHours(false);
    setDefaultHoursChanged(false);
  };

  const handleConfirmHours = async () => {
    if (hoursWarning === true) {
      setHoursWarning(false);
    }
    setConfirmHours(true);
    setDefaultHoursChanged(true);
  };

  //Change Hours
  const handleTimeChange = (dayOfWeek, field, value) => {
    if (confirmHours) {
      setConfirmHours(false);
    }
    setDefaultHoursChanged(true);
    // Update state directly for immediate feedback
    if (field === "start_time") {
      setStartTimeValues((prev) => ({
        ...prev,
        [dayOfWeek]: value,
      }));
    } else if (field === "end_time") {
      setEndTimeValues((prev) => ({
        ...prev,
        [dayOfWeek]: value,
      }));
    }

    // Update business hours
    setBusinessHours((prev) => ({
      ...prev,
      [dayOfWeek]: {
        ...prev[dayOfWeek],
        [field]: value,
      },
    }));
  };

  //New Employee Hooks
  const handleTogglePinVisibility = () => {
    setShowPin(!showPin);
  };

  const handleConfirmNewPinChange = (e) => {
    const inputValue = e.target.value.replace(/\D/g, "").substr(0, 4);
    setConfirmNewPin(inputValue);
  };

  const toggleShowConfirmNewPin = () => {
    setShowConfirmNewPin((prev) => !prev);
  };

  useEffect(() => {
    const isValidInput =
      pin.length >= 4 &&
      pin.length <= 4 &&
      /^\d+$/.test(pin) &&
      confirmNewPin.length === 4 &&
      /^\d+$/.test(confirmNewPin) &&
      pin === confirmNewPin &&
      userNameTaken === false &&
      userName.trim() !== "";

    setIsSaveUserButtonEnabled(isValidInput);
  }, [pin, confirmNewPin, firstName, lastName, newUserName, userNameTaken]);

  const handleEditUser = () => {
    setIsAssignEmployeeVisible(true);
    setHideCreateUserButton(true);
    setIsEditingUser(true);
  };

  /// Transfer List Logic
  const handleToggle = (value) => () => {
    if (!Array.isArray(checked)) {
      setChecked([]);
      return;
    }

    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };

  const [usersMoved, setUsersMoved] = useState(false);

  const handleCheckedRight = () => {
    // Map over selected users to add `isNewUser: false` to each user object
    const selectedUsers = checked
      .filter((user) => left.includes(user))
      .map((user) => ({ ...user, isNewUser: false }));

    // Move modified users to `right` and remove them from `left`
    setRight(right.concat(selectedUsers));
    setLeft(left.filter((user) => !checked.includes(user)));

    setChecked([]);

    // Set the first user as `assignedUser` if any users are selected
    if (selectedUsers?.length > 0) {
      setAssignedUser(selectedUsers[0]);
      setConfirmUsers(false);

      setUsersMoved(true);
    }
  };

  const handleCheckedLeft = () => {
    const selectedUsers = checked.filter(
      (user) => right.includes(user) && !user.isNewUser,
    );
    setLeft(left.concat(selectedUsers));
    setRight(right.filter((user) => !checked.includes(user) || user.isNewUser));
    setChecked([]);

    if (selectedUsers?.some((user) => user === assignedUser)) {
      setAssignedUser(null);
      setAssignedLocation(null);
      setConfirmUsers(false);
    }
  };

  // When creating a new employee, reset relevant states
  const handleCreateNewEmployeeClick = async () => {
    setAssignedUser(null);
    setAssignedLocation(null);
    setIsAssignEmployeeVisible(true);
    setHideCreateUserButton(true);
  };

  const handleAssignEmployeeClick = async () => {
    setAssignedUser(null);
    setAssignedLocation(null);
    setRight([]);
    setLeft(availableUsers);
    setIsAssignEmployeeVisible(false);
    setHideCreateUserButton(true);
  };

  // Save new user and add to the right list
  const handleSaveNewUserClick = async () => {
    const newUser = {
      first_name: firstName,
      last_name: lastName,
      user_name: userName, // Use this as the unique identifier if user_id is not present
      pin,
      is_admin: isAdmin,
      isNewUser: true,
    };

    setRight((prevRight) => {
      const existingUserIndex = prevRight.findIndex(
        (user) => user.user_name === newUser.user_name,
      );

      if (enableEditButtons && existingUserIndex !== -1) {
        // If editing and user exists, update the existing user
        const updatedRight = [...prevRight];
        updatedRight[existingUserIndex] = newUser;
        setConfirmUsers(false);
        return updatedRight;
      } else if (existingUserIndex === -1) {
        setNewUserCreated(true);
        setConfirmUsers(false);
        return [...prevRight, newUser];
      }
      return prevRight;
    });

    // Reset states and hide form
    setIsNewUserSaved(true);
    setIsAssignEmployeeVisible(false);
    setHideCreateUserButton(true);
    setChecked([]);
  };

  // Clear new user data (delete button)
  const handleClearNewUserClick = () => {
    setNewUserId(null);
    setFirstName("");
    setLastName("");
    setUserName("");
    setPin("");
    setConfirmNewPin("");
    setNewUserName("");
    setHideCreateUserButton(false);
    setIsNewUserSaved(false);
    setShowConfirmNewPin(false);
    setConfirmNewPin("");
    setIsAssignEmployeeVisible(false);
    setEnableEditButtons(false);
    setConfirmUsers(false);
    setLeft(availableUsers);
    setRight((prevRight) => prevRight.filter((user) => !user.isNewUser));
    setChecked([]);
  };

  useEffect(() => {
    right.forEach((user) => {
      setNewUserCreated(true);
    });
  }, [right]);

  useEffect(() => {
    const hasNewUser = Object.values(checked)?.some(
      (user) => user.isNewUser === true,
    );

    if (hasNewUser && checked?.length === 1) {
      setEnableEditButtons(true);
    } else {
      setEnableEditButtons(false);
    }
  }, [checked]);

  const handleUpdateChecklist = async () => {
    const userId = user.sub;
    if (accountData.onboarding_complete === false) {
      await dismissItem(item, getAccessTokenSilently, userId);
      await fetchOnboardingRecord();
      return;
    } else {
      return;
    }
  };

  const handleCancelEdit = () => {
    setIsAssignEmployeeVisible(false);
    setHideCreateUserButton(false);
  };

  const handleCancelAddUser = () => {
    if (enableEditButtons) {
      setIsAssignEmployeeVisible(false);
      setHideCreateUserButton(false);
      setChecked([]);
    } else {
      setFirstName("");
      setLastName("");
      setPin("");
      setUserName("");
      setNewUserName("");
      setIsAssignEmployeeVisible(false);
      setHideCreateUserButton(false);
      setChecked([]);
      setIsAdmin(false);
    }
  };

  const handleConfirmUsers = () => {
    setConfirmUsers(true);
    if (usersWarning === true) {
      setUsersWarning(false);
    }
  };

  const handleResetEmployees = () => {
    setRight([]);
    setLeft(availableUsers);
    setNewUserId(null);
    setFirstName("");
    setLastName("");
    setPin("");
    setUserName("");
    setNewUserName("");
    setHideCreateUserButton(false);
    setIsAssignEmployeeVisible(false);
    setAssignedUser(null);
    setAssignedLocation(null);
    setConfirmNewPin("");
    setShowConfirmNewPin(false);
    setIsNewUserSaved(false);
    setConfirmUsers(false);
    setChecked([]);
    setUsersMoved(false);
    setUsersWarning(false);
  };

  const [addedUserCost, setAddedUserCost] = useState("");

  const clearData = () => {
    setName("");
    setEmail("");
    setPhone("");
    setNameTouched(false);
    setEmailTouched(false);
    setPhoneTouched(false);
    setRight([]);
    setLeft(availableUsers);
    setNewUserId(null);
    setFirstName("");
    setLastName("");
    setPin("");
    setUserName("");
    setNewUserName("");
    setHideCreateUserButton(false);
    setIsAssignEmployeeVisible(false);
    setAssignedUser(null);
    setAssignedLocation(null);
    setConfirmNewPin("");
    setShowConfirmNewPin(false);
    setIsNewUserSaved(false);
    setSelectedTab(0);
    setChecked([]);
    setNewUserCreated(false);
    setHoursWarning(false);
    setUsersWarning(false);
    setConfirmHours(false);
    setDefaultHoursChanged(false);
    setBusinessHours(defaultBusinessHours);
    setStartTimeValues(defaultStartTimeValues);
    setEndTimeValues(defaultEndTimeValues);
    setIsCancelCloseOpen(false);
    setOpenConfirmDialog(false);
    setOpenReviewDialog(false);
    setIsAdmin(false);
    setUserNameTaken(false);
    setConfirmUsers(true);
    setUsersMoved(false);
    setDefaultLeft(availableUsers);
    if (
      totalLocations &&
      totalLocations.length === totalUsers &&
      totalUsers.length
    ) {
      setAddedUserCost("$0/month");
    } else {
      setAddedUserCost("$5/month");
    }
  };

  useEffect(() => {
    if (open) {
      clearData();
    }
  }, [open]);

  const handleCreateNewLocationClick = async () => {
    // Trigger warnings if applicable
    if (defaultHoursChanged && !confirmHours) {
      setHoursWarning(true);
      return;
    }
    if (right.length > 0 && !confirmUsers) {
      setUsersWarning(true);
      return;
    }

    // Prepare confirmation message if needed
    const conditions = [];
    if (right.length === 0) conditions.push("no active employees");
    if (!defaultHoursChanged) conditions.push("default hours");

    if (conditions.length > 0) {
      setConfirmMessage(
        `Are you sure you want to create a new location with ${conditions.join(" and ")}?`,
      );
      handleOpenConfirmDialog();
    } else {
      handleOpenReviewDialog();
    }
  };

  const singleUser =
    accountData &&
    accountData.single_user === false &&
    accountData.total_employees === 1;

  const singleLocation =
    accountData &&
    accountData.single_location === false &&
    accountData.total_locations === 1;

  const customerId = accountData?.customer_id;

  const handleNewLocationSubmit = async () => {
    if (openConfirmDialog === true) {
      setOpenConfirmDialog(false);
    }

    try {
      setIsLoading(true);
      // Submit new location details
      const result = await AddLocationSubmit(
        getAccessTokenSilently,
        name,
        email,
        phone,
        businessHours,
        userId,
        right,
        customerId,
      );
      fetchLocations();
      fetchUsers();

      handleUpdateChecklist();
      handleSubscriptionUpdate();
      onClose();
      showSnackBar("Location Added", true);


        await fetchAccountData(userId);
        await refetchSubscriptionDetails();
        await refreshSubscription();
        handleReloadComponents();
    
    } catch (error) {
      console.error("Failed to create location:", error);

      // Check if error message matches 'Location name is already taken.'
      if (error.message === "Location name is already taken.") {
        setOpenConfirmDialog(false);
        setOpenReviewDialog(false);

        showSnackBar("Location name is already in use", false);
        setLocationNameTaken(true);
      } else if (error.message === "Username is already taken.") {
        setSelectedTab(2);
        setIsAssignEmployeeVisible(true);
        setOpenConfirmDialog(false);
        setOpenReviewDialog(false);
        showSnackBar("Username is already in use", false);
        setUserNameTaken(true);
      } else {
        showSnackBar("Failed to create location. Please try again.", false);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };

  // Validate Unique Location Name
  useEffect(() => {
    // Check if any location's name matches the input `name`, ignoring case
    const isLocationNameTaken = locations?.some(
      (location) => location.name.toLowerCase() === name.toLowerCase(),
    );

    // Set state based on whether the location name is taken
    setLocationNameTaken(isLocationNameTaken);
  }, [name, locations]); // Trigger when name or locations change

  return (
    <Dialog
      open={open}
      onClose={handleOpenCancelCloseDialog}
      PaperProps={{ sx: { borderRadius: "13px", width: "550px" } }}
    >
      <Box
        sx={{
          padding: "10px",
          backgroundColor: "#FFFFFFF",
          minHeight: "20vh",
        }}
      >
        <IconButton
          aria-label="close"
          onClick={handleOpenCancelCloseDialog}
          sx={{
            position: "absolute",
            right: 4,
            top: 7,
            color: "#7589A2",
            backgroundColor: "transparent",
            zIndex: 1,
            borderRadius: "12px",
            width: "35px",
            height: "35px",
            padding: "3px",
          }}
        >
          <CloseIcon sx={{ fontSize: "28px" }} />
        </IconButton>
        <Box sx={{ px: "5px" }}>
          <Stack
            direction="column"
            sx={{
              display: "flex",
              width: "100%",
              backgroundColor: "#FFFFFFF",

              color: "#374247",
              mt: 1,
            }}
          >
            <img
              src={addLocationIcon}
              alt="addLocationIcon"
              style={{
                border: ".5px solid #B0BEC5",
                width: "28px",
                height: "28px",
                backgroundColor: "#FFFFFF",
                borderRadius: "10px",
                padding: "1px",
                boxShadow: "0px 1px 1px rgba(0, 0, 0, 0.09)",
                borderRadius: "6px",
                mb: "15px",
              }}
            />
            <Typography
              sx={{
                color: "#48768C",
                fontWeight: 600,
                lineHeight: "-2%",
                letterSpacing: "-.2px",
                fontSize: "18.5px",
                mb: "15px",
                mt: "3px",
              }}
            >
              Create New Location{" "}
            </Typography>
          </Stack>
        </Box>

        <DialogContent sx={{ padding: 0, backgroundColor: "#FFFFFFF" }}>
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            sx={{
              ml: 0.65,
              minHeight: "15px",
              maxHeight: "25px",
              borderRadius: "8px 8px 0 0",
              backgroundColor: "transparent",
              ".MuiTabs-indicator": { backgroundColor: "transparent" },
            }}
          >
            <Tab
              label="Contact Info"
              sx={{
                color: "#48768C",
                fontWeight: 500,
                textTransform: "none",
                borderTop: "1px solid #ADD8E6",
                borderLeft: "1px solid #ADD8E6",
                borderRight: "1px solid #ADD8E6",
                borderRadius: "8px 8px 0 0",
                backgroundColor: "#F2F9FF",
                mb: "-1px",
                fontSize: 14.36,
                minHeight: "25px",
                padding: "4px 32px",
                lineHeight: "-2%",
                pb: 1.25,
                mr: 0.35,
                "&.Mui-selected": {
                  color: "#48768C",
                  fontWeight: 600,
                  backgroundColor: "#E0F3FF", // Slightly different background when selected
                  paddingTop: "6px", // Increase top padding to simulate height increase
                  paddingBottom: "8px", // Increase bottom padding as well
                },
              }}
            />
            <Tab
              label="Location Hours"
              sx={{
                color: "#48768C",
                fontWeight: 500,
                textTransform: "none",
                borderTop: hoursWarning
                  ? "1.5px solid #8C4350"
                  : "1px solid #ADD8E6",
                borderLeft: hoursWarning
                  ? "1.5px solid #8C4350"
                  : "1px solid #ADD8E6",
                borderRight: hoursWarning
                  ? "1.5px solid #8C4350"
                  : "1px solid #ADD8E6",
                borderRadius: "8px 8px 0 0",
                backgroundColor: "#F2F9FF",
                mb: "-1px",
                fontSize: 14.36,
                minHeight: "25px",
                padding: "4px 12px",
                pb: 1.45,
                mr: 0.35,
                "&.Mui-selected": {
                  color: "#48768C",
                  fontWeight: 600,
                  backgroundColor: "#E0F3FF",
                  paddingTop: "6px",
                  paddingBottom: "8px",
                  borderBottom: hoursWarning
                    ? "2px solid #8C4350"
                    : "2px solid #ADD8E6", // Optional: Add a bottom border to emphasize the active state
                  borderTop: hoursWarning
                    ? "1.5px solid #8C4350"
                    : "1px solid #ADD8E6",
                  borderLeft: hoursWarning
                    ? "1.5px solid #8C4350"
                    : "1px solid #ADD8E6",
                  borderRight: hoursWarning
                    ? "1.5px solid #8C4350"
                    : "1px solid #ADD8E6",
                },
              }}
            />
            <Tab
              label="Manage Employees"
              sx={{
                color: "#48768C",
                fontWeight: 500,
                textTransform: "none",
                borderTop: usersWarning
                  ? "1.5px solid #8C4350"
                  : "1px solid #ADD8E6",
                borderLeft: usersWarning
                  ? "1.5px solid #8C4350"
                  : "1px solid #ADD8E6",
                borderRight: usersWarning
                  ? "1.5px solid #8C4350"
                  : "1px solid #ADD8E6",
                borderRadius: "8px 8px 0 0",
                backgroundColor: "#F2F9FF",
                mb: "-1px",
                fontSize: 14.36,
                minHeight: "25px",
                padding: "4px 12px",
                pb: 1.45,
                mr: 0.35,
                "&.Mui-selected": {
                  color: "#48768C",
                  fontWeight: 600,
                  backgroundColor: "#E0F3FF",
                  paddingTop: "6px",
                  paddingBottom: "8px",
                  borderBottom: usersWarning
                    ? "2px solid #8C4350"
                    : "2px solid #ADD8E6", // Optional: Add a bottom border to emphasize the active state
                  borderTop: usersWarning
                    ? "1.5px solid #8C4350"
                    : "1px solid #ADD8E6",
                  borderLeft: usersWarning
                    ? "1.5px solid #8C4350"
                    : "1px solid #ADD8E6",
                  borderRight: usersWarning
                    ? "1.5px solid #8C4350"
                    : "1px solid #ADD8E6",
                },
              }}
            />
          </Tabs>
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              zIndex: 0,
              backgroundColor: "#F2F9FF",
              border: "1px solid rgba(173, 216, 230, 0.7)",
              overflowY: "auto",
              px: "10px",
              borderRadius: "8px",
              mb: 2,
            }}
          >
            {/* Tabs at the top of the Dialog */}

            <Box sx={{ mt: 1.5, width: "100%", minHeight: "20vh" }}>
              {/* Tab Panel for Location Info */}
              <Fade in={selectedTab === 0} timeout={600}>
                <Box sx={{ display: selectedTab === 0 ? "block" : "none" }}>
                  <>
                    <Typography
                      sx={{
                        color: "#48768C",
                        fontWeight: 600,
                        fontSize: 16.36,
                        mb: "15px",
                        mt: "2px",
                        letterSpacing: -0.1,
                        lineHeight: -2,
                      }}
                    >
                      Location Info
                    </Typography>
                    <LocationInfoCard
                      name={name}
                      email={email}
                      phone={phone}
                      handleNameChange={handleNameChange}
                      handleBlur={handleBlur}
                      handleEmailBlur={handleEmailBlur}
                      handleEmailChange={handleEmailChange}
                      handlePhoneChange={handlePhoneChange}
                      handlePhoneBlur={handlePhoneBlur}
                      nameTouched={nameTouched}
                      emailTouched={emailTouched}
                      phoneTouched={phoneTouched}
                      isFormValid={isFormValid}
                      setIsFormValid={setIsFormValid}
                      validateEmail={validateEmail}
                      validatePhoneNumber={validatePhoneNumber}
                      handleOpenCancelCloseDialog={handleOpenCancelCloseDialog}
                      isCancelCloseOpen={isCancelCloseOpen}
                      handleCloseCancelCloseDialog={
                        handleCloseCancelCloseDialog
                      }
                      handleCreateNewLocationClick={
                        handleCreateNewLocationClick
                      }
                      locationNameTaken={locationNameTaken}
                      isLoading={isLoading}
                      hoursWarning={hoursWarning}
                      usersWarning={usersWarning}
                    />
                  </>
                </Box>
              </Fade>

              <Fade in={selectedTab === 1} timeout={600}>
                <Box sx={{ display: selectedTab === 1 ? "block" : "none" }}>
                  <>
                    <Typography
                      sx={{
                        color: "#48768C",
                        fontWeight: 600,
                        fontSize: 16.36,
                        mb: "20px",
                        mt: "5px",
                      }}
                    >
                      Location Hours of Operation
                    </Typography>
                    <LocationHoursCard
                      handleUpdateChecklist={handleUpdateChecklist}
                      handleOpenReviewDialog={handleOpenReviewDialog}
                      hoursItem={hoursItem}
                      setHoursItem={setHoursItem}
                      businessHours={businessHours}
                      setBusinessHours={setBusinessHours}
                      startTimeValues={startTimeValues}
                      setStartTimeValues={setStartTimeValues}
                      endTimeValues={endTimeValues}
                      setEndTimeValues={setEndTimeValues}
                      handleTimeChange={handleTimeChange}
                      isSaveHoursButtonDisabled={isSaveHoursButtonDisabled}
                      setIsSaveHoursButtonDisabled={
                        setIsSaveHoursButtonDisabled
                      }
                    />
                    <Stack
                      direction="row"
                      spacing={2}
                      sx={{ mt: 5, mb: 2, width: "60%", ml: "auto" }}
                    >
                      <Button
                        onClick={handleResetHours}
                        disabled={!defaultHoursChanged}
                        sx={{
                          border: "1px solid #8C435029",
                          borderRadius: "6px",
                          color: "#8C4350",
                          backgroundColor: "#8C435021",
                          padding: "1px 0", // Same padding as the first button
                          fontSize: 13.76, // Matching font size for consistency
                          width: "415px",
                          height: "35px", // Fixed height to match the first button
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            backgroundColor: "#8C435017",
                          },
                          "&:active": {
                            backgroundColor: "#A4C5D230",
                          },
                        }}
                      >
                        Reset To Default
                      </Button>
                      <Button
                        onClick={handleConfirmHours}
                        disabled={
                          confirmHours ||
                          !defaultHoursChanged ||
                          isSaveHoursButtonDisabled
                        }
                        sx={{
                          whiteSpace: "pre-wrap",
                          border: "1px solid #A4C5D2E8",
                          borderRadius: "6px",
                          padding: "1px 0", // Consistent padding
                          color: "#48768C",
                          backgroundColor: "#FFFFFF",
                          fontSize: 13.76,
                          width: "490px",
                          height: "35px", // Fixed height to match the first button
                          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                          "&:hover": {
                            backgroundColor: "#DBEAF0",
                          },
                          "&:active": {
                            backgroundColor: "#DBEAF0",
                          },
                        }}
                      >
                        {confirmHours ? "Hours Saved" : "Save Hours"}
                      </Button>
                    </Stack>
                  </>
                </Box>
              </Fade>

              <Fade in={selectedTab === 2} timeout={600}>
                <Box sx={{ display: selectedTab === 2 ? "block" : "none" }}>
                  {" "}
                  <>
                    <EmployeeSetupCard
                      users={users}
                      subUserData={subUserData}
                      name={name}
                      handleToggle={handleToggle}
                      checked={checked}
                      left={left}
                      right={right}
                      handleCheckedRight={handleCheckedRight}
                      handleCheckedLeft={handleCheckedLeft}
                      setLeft={setLeft}
                      userNameTaken={userNameTaken}
                      hideCreateUserButton={hideCreateUserButton}
                      isAssignEmployeeVisible={isAssignEmployeeVisible}
                      handleCreateNewEmployeeClick={
                        handleCreateNewEmployeeClick
                      }
                      handleSaveNewUserClick={handleSaveNewUserClick}
                      firstName={firstName}
                      setFirstName={setFirstName}
                      lastName={lastName}
                      setLastName={setLastName}
                      pin={pin}
                      setPin={setPin}
                      showPin={showPin}
                      handleTogglePinVisibility={handleTogglePinVisibility}
                      confirmNewPin={confirmNewPin}
                      handleConfirmNewPinChange={handleConfirmNewPinChange}
                      showConfirmNewPin={showConfirmNewPin}
                      toggleShowConfirmNewPin={toggleShowConfirmNewPin}
                      isSaveUserButtonEnabled={isSaveUserButtonEnabled}
                      assignedUser={assignedUser}
                      assignedLocation={assignedLocation}
                      handleUpdateChecklist={handleUpdateChecklist}
                      setHideCreateUserButton={setHideCreateUserButton}
                      handleAssignEmployeeClick={handleAssignEmployeeClick}
                      setUserName={setUserName}
                      newUserId={newUserId}
                      newUserCreated={newUserCreated}
                      enableEditButtons={enableEditButtons}
                      isNewUserSaved={isNewUserSaved}
                      isAdmin={isAdmin}
                      setIsAdmin={setIsAdmin}
                      handleCancelAddUser={handleCancelAddUser}
                      userName={userName}
                      handleClearNewUserClick={handleClearNewUserClick}
                      handleConfirmUsers={handleConfirmUsers}
                      confirmUsers={confirmUsers}
                      isEditingUser={isEditingUser}
                      handleCancelEdit={handleCancelEdit}
                      setUserNameTaken={setUserNameTaken}
                    />
                    {!isAssignEmployeeVisible &&
                      isNewUserSaved &&
                      enableEditButtons && (
                        <Stack
                          direction="row"
                          spacing={2}
                          sx={{ mt: 2, mb: 2, width: "60%", ml: "auto" }}
                        >
                          <Button
                            onClick={handleClearNewUserClick}
                            disabled={!enableEditButtons}
                            sx={{
                              border: "1px solid #8C435029",
                              borderRadius: "6px",
                              color: "#8C4350",
                              backgroundColor: "#8C435021",
                              padding: "1px 0", // Same padding as the first button
                              fontSize: 13.76, // Matching font size for consistency
                              width: "415px",
                              height: "35px", // Fixed height to match the first button
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              "&:hover": {
                                backgroundColor: "#8C435017",
                              },
                              "&:active": {
                                backgroundColor: "#A4C5D230",
                              },
                            }}
                          >
                            Delete
                          </Button>
                          <Button
                            onClick={handleEditUser}
                            disabled={!enableEditButtons}
                            sx={{
                              whiteSpace: "pre-wrap",
                              border: "1px solid #A4C5D2E8",
                              borderRadius: "6px",
                              padding: "1px 0", // Consistent padding
                              color: "#48768C",
                              backgroundColor: "#FFFFFF",
                              fontSize: 13.76,
                              width: "490px",
                              height: "35px", // Fixed height to match the first button
                              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                              "&:hover": {
                                backgroundColor: "#DBEAF0",
                              },
                              "&:active": {
                                backgroundColor: "#DBEAF0",
                              },
                            }}
                          >
                            Edit
                          </Button>
                        </Stack>
                      )}
                    {!isAssignEmployeeVisible && !enableEditButtons && (
                      <Stack
                        direction="row"
                        spacing={2}
                        sx={{ mt: 2, mb: 2, width: "60%", ml: "auto" }}
                      >
                        <Button
                          onClick={handleResetEmployees}
                          disabled={right.length === 0}
                          sx={{
                            border: "1px solid #8C435029",
                            borderRadius: "6px",
                            color: "#8C4350",
                            backgroundColor: "#8C435021",
                            padding: "1px 0", // Same padding as the first button
                            fontSize: 13.76, // Matching font size for consistency
                            width: "415px",
                            height: "35px", // Fixed height to match the first button
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              backgroundColor: "#8C435017",
                            },
                            "&:active": {
                              backgroundColor: "#A4C5D230",
                            },
                          }}
                        >
                          Reset
                        </Button>
                        <Button
                          onClick={handleConfirmUsers}
                          disabled={right.length === 0 || confirmUsers}
                          sx={{
                            whiteSpace: "pre-wrap",
                            border: "1px solid #A4C5D2E8",
                            borderRadius: "6px",
                            padding: "1px 0", // Consistent padding
                            color: "#48768C",
                            backgroundColor: "#FFFFFF",
                            fontSize: 13.76,
                            width: "490px",
                            height: "35px", // Fixed height to match the first button
                            boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                            "&:hover": {
                              backgroundColor: "#DBEAF0",
                            },
                            "&:active": {
                              backgroundColor: "#DBEAF0",
                            },
                          }}
                        >
                          {confirmUsers ? "Employees Saved" : "Save Employees"}
                        </Button>
                      </Stack>
                    )}
                  </>
                </Box>
              </Fade>
            </Box>
          </Box>
        </DialogContent>

        {openReviewDialog && (
          <Portal>
            <ReviewDialog
              open={openReviewDialog}
              onClose={handleCloseReviewDialog}
              addedUserPrice="+ $10/month"
   
              buttonText="Confirm & Add Location"
              isLoading={isLoading}
              buttonLoadingText="Adding Location..."
              name={name}
              email={email}
              phone={phone}
              buttonAction={handleNewLocationSubmit}
              handleCancel={onClose}
              CancelCloseMessage="Are you sure you want to close?"
              CancelCloseSubText="Your new location will not be created."
              subscriptionDetails={subscriptionDetails}
              planDetails={planDetails}
              addedUser={userName ? true : false}  // Pass this dynamically based on the action
              addedLocation={true}
              deletedUser={false}
              deletedLocation={false}
              upgradedPlan={false}
              downgradedPlan={false}

            />
          </Portal>
        )}
      </Box>
      <CancelCloseDialog
        open={isCancelCloseOpen}
        onClose={handleCloseCancelCloseDialog}
        buttonAction={handleCancelClose}
        onCloseConfirm={onClose}
        CancelCloseMessage="Are you sure you want to close?"
        CancelCloseSubText="Your new location will not be created."
      />
      <ConfirmDialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog} // Just close dialog without submission
        header="Confrim Your Changes"
        message={confirmMessage}
        subText=""
        buttonAction={handleOpenReviewDialog} // Close and submit
        buttonText="Create New Location"
        cancelButtonText="Continue Editing"
      />
    </Dialog>
  );
};

export default AddLocationModal;
